export const fullCenter = `
  align-items: center;
  display: flex;
  justify-content: center;
`;
